export default __webpack_public_path__ + "static/media/mintpass-gif.91e5f0b8.gif";